import { useEffect, useState } from "react";
import { clientCMSpet } from "../../sanity/clientCMSpet.js";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PiDog } from "react-icons/pi";
import { PiCat } from "react-icons/pi";
import { PiBird } from "react-icons/pi";
import { PiHorse } from "react-icons/pi";
import { PiHeart } from "react-icons/pi";
import { LuPawPrint } from "react-icons/lu";
import "./AllStars.css";

export default function AllStars(props) {
  const [allStarsData, setAllStarsData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMSpet
      .fetch(
        `*[_type == "pet"] | order(publishedAt desc) {
        name,
        "breed": breed->name,
        "message": message->description,
        "city": city->title,
        mainImage{
            asset->{
            _id,
            url
            },
        },
        publishedAt
    }`
      )
      .then((data) => {
        setAllStarsData(data);
        if (data.length === 0)
          setDataContainer(
            <div className="no-data-container">
              <LuPawPrint className="no-data-container-icon" /> Sem estrelinhas
              no momento
            </div>
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!allStarsData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  return (
    <Container>
      <Row>
        {allStarsData && allStarsData.length > 0
          ? allStarsData &&
            allStarsData.map((pet, index) => (
              <Col key={index} className="noticias-col">
                <div
                  style={{ backgroundColor: props.white }}
                  className="star-card"
                >
                  <img
                    src={pet.mainImage.asset.url}
                    alt="imagem pet"
                    className="star-card-img"
                  />
                  <div className="star-card-content">
                    <div className="star-card-title">
                      {pet.breed === "Cachorro" ? (
                        <PiDog
                          style={{ color: props.iconColor }}
                          className="star-card-icon"
                        />
                      ) : (
                        ""
                      )}
                      {pet.breed === "Gato" ? (
                        <PiCat
                          style={{ color: props.iconColor }}
                          className="star-card-icon"
                        />
                      ) : (
                        ""
                      )}
                      {pet.breed === "Passaro" ? (
                        <PiBird
                          style={{ color: props.iconColor }}
                          className="star-card-icon"
                        />
                      ) : (
                        ""
                      )}
                      {pet.breed === "Cavalo" ? (
                        <PiHorse
                          style={{ color: props.iconColor }}
                          className="star-card-icon"
                        />
                      ) : (
                        ""
                      )}
                      {pet.breed === "Outra" ? (
                        <PiHeart
                          style={{ color: props.iconColor }}
                          className="star-card-icon"
                        />
                      ) : (
                        ""
                      )}
                      <h3
                        style={{
                          color: props.titleColor,
                          fontSize: props.subTitleSize,
                        }}
                      >
                        {pet.name}
                      </h3>
                    </div>
                    <p
                      style={{
                        color: props.textColor,
                        fontSize: props.subTextSize,
                      }}
                    >
                      {pet.message}
                    </p>
                    <h4
                      style={{
                        color: props.textColor,
                        fontSize: props.textSize,
                      }}
                    >
                      {pet.city}
                    </h4>
                  </div>
                </div>
              </Col>
            ))
          : dataContainer}
      </Row>
    </Container>
  );
}
